import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import HolidayCalendar from '../../entities/holidayCalendar';

/*
 * Delete/nullify anywhere this holidayCalendar is used in other entities
 *
 * @param {HolidayCalendar} holidayCalendar
 */
export function deleteHolidayCalendar(holidayCalendar: HolidayCalendar, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = holidayCalendar.id;
    }

    /* Remove the actual holidayCalendar */
    holidayCalendar.status = 'D';
    holidayCalendar.addedOn = newHRTimestamp();
    holidayCalendar.addedBy = getCurrentUserId();
    holidayCalendar.importSource = targetImportSource;
    holidayCalendar.importId = mergeId;
    store.dispatch(Actions.HolidayCalendarActions.removeHolidayCalendarQueue(holidayCalendar));
    
}